import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreferenceService } from '../../../services/preference.service';
import { TreeNode } from 'primeng/api';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { Router, ActivatedRoute } from '@angular/router';
import * as fromFeature from '../../../my-features';
import { CryptoService } from '../../../services/crypto.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PaymentTypeIndex } from '../../../shareModel'

@Component({
  standalone: false,
  selector: 'app-document-detail',
  templateUrl: './document-detail.component.html',
  styleUrls: ['./document-detail.component.css']
})
export class PaymentDocumentDetailComponent implements OnInit {
  private componentDestroyed = new Subject();
  deviceUsageTable_cols: any[] = [
    { field: 'Company', header: 'Company Name', width: '360', class: 'col-nowrap' },
    { field: '', header: 'Quantity (Last month)', width: '220', class: 'col-nowrap' },
    { field: '', header: 'Growth Amount', width: '220', class: 'col-nowrap' },
    { field: '', header: 'Quantity (This month)', width: '220', class: 'col-nowrap' },
    // { field: 'UnitPrice', header: 'Unit Price (USD/mon)', width: '220', class: 'col-nowrap' },
    // { field: 'Amount', header: 'Amount (USD)', width: '220', class: 'col-nowrap' },
  ];
  summaryTable_cols: any[] = [
    { field: 'Company', header: 'Model Name', width: '360', class: 'col-nowrap' },
    { field: 'UsedDevice', header: 'Quantity (NPM)', width: '220', class: 'col-nowrap' },
    { field: 'UnitPrice', header: 'Unit Price (USD)', width: '220', class: 'col-nowrap' },
    { field: 'Amount', header: 'Total Amount (USD)', width: '220', class: 'col-nowrap' },
  ];
  datePickStart: Date;
  deviceUsageList: TreeNode[];
  summaryList: TreeNode[];
  deviceUsageTotal = {
    name: '',
    quantity: 0,
    last_quantity: 0,
    unitprice: 0,
    amount: 0,
  };
  summaryTotal = {
    name: '',
    quantity: 0,
    unitprice: 0,
    amount: 0,
  };
  docDetailInfo = {
    Company: '',
    CompanyEmail: '',
    DocNo: '',
    MonthYear: '',
    DocDate: '',
    Period: '',
    IsDistributorAll: false,
    DocType: 0,
    MinCharge: 0,
    RegionName: '',
    PaymentType: 0,
    CreateId: 0,
    CreateAccount: '',
    CorrNo: '',
    IsFree: false
  };
  getMspDocParam = {
    otp: '',
    DocId: 0
  };
  getPaymentSettingParam = {
    otp: '',
    RegionId: []
  };
  isMspLoaded = false;
  show_Doc_Info = {
    Summary: false,
    Detail: false
  };
  PaymentTypeIndex = PaymentTypeIndex;
  constructor( private ngxService: NgxUiLoaderService, private _location: Location, public preferenceService: PreferenceService,
    private route: ActivatedRoute, private cryptoService: CryptoService, private store: Store<fromStore.State>, private router: Router,
  ) {
    const docId = parseInt(this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('id')))
    this.getMspDocParam = {
      ...this.getMspDocParam,
      DocId: docId,
    };
    this.store.dispatch(new fromFeature.ReadMspPaymentDocument({ ...this.getMspDocParam }));
    this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getPaymentSettingParam }));

    this.getDefaultDate();
  
    // Msp Data
    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getCurrentUser))
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getIsMspRes, getCurrentUserRes]) => {
      if ((getIsMspRes !== undefined && getIsMspRes !== null) && (getCurrentUserRes !== undefined && getCurrentUserRes !== null)) {
        // Get IsMsp
        this.isMspLoaded = true;
        if (getIsMspRes && getCurrentUserRes.authority === 1) {
          this.router.navigate(['/dashboard']);
        }
        this.ngxService.stop();
      }
    });

    // Get Payment Document
    this.store.select(fromStore.getMspPaymentDocument).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== null && res !== undefined) {
        this.docDetailInfo = {
          Company: res.Company,
          CompanyEmail: res.CompanyEmail,
          DocNo: res.DocNo,
          MonthYear: res.MonthYear,
          DocDate: res.CreateTime,
          Period: res.Period,
          IsDistributorAll: res.IsDistributorAll,
          DocType: res.DocType,
          MinCharge: res.MinCharge,
          RegionName: res.RegionName,
          PaymentType: res.PaymentType,
          CreateId: res.CreateId,
          CreateAccount: res.CreateAccount,
          CorrNo: res.CorrNo,
          IsFree: res.IsFree
        }
        this.summaryList = [];
        this.deviceUsageList = [];
        res.deviceUsage.map((d) => {
          if (d.data !== undefined && d.name == undefined ) {
            this.deviceUsageList.push({
              data: { ...d.data },
              expanded: d.expanded,
              children: Array.isArray(d.children)
                ? d.children.map((c) => ({
                    ...c,
                    data: c.data ? { ...c.data } : c.data,
                  }))
                : d.children
            });

            this.summaryList.push({
              data: { ...d.data },
              expanded: d.expanded,
              // require: d.isDefaultQuantity
            });
            
          } else {
            if (d.type === 0) {
              this.deviceUsageTotal.quantity = d.quantity;
              this.deviceUsageTotal.last_quantity = d.last_quantity;
              this.deviceUsageTotal.name = d.name;
            } else {
              this.summaryTotal.quantity = d.quantity;
              this.summaryTotal.unitprice = d.unitprice;
              this.summaryTotal.amount = d.amount;
              this.summaryTotal.name = d.name;
            }
          }
        });
        // this.deviceUsageTotal.name = res.Usage[1].name;
        // this.deviceUsageTotal.quantity = res.Usage[1].quantity;
        // this.deviceUsageTotal.unitprice = res.Usage[1].unitprice;
        // this.deviceUsageTotal.amount = res.Usage[1].amount;
        this.show_Doc_Info.Summary = true;
        this.show_Doc_Info.Detail = this.docDetailInfo.PaymentType === PaymentTypeIndex.Monthly;
        
        this.ngxService.stop();
      }
    });
  }

  ngOnInit() {
    this.ngxService.start();
  }

  backClicked() {
    this._location.back();
  }

  getDefaultDate() {
    const today = new Date();
    const preDate = new Date(today);
    this.datePickStart = preDate;
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

}
